<template>
  <div class="order-risk-trace-list-container">
    <!-- 筛选查询表单 -->
    <v-centerForm>
      <template slot='left'>
        <el-form inline :model="searchForm" ref="searchForm" label-width="100px">
          <!-- 核心查询字段 -->
          <el-form-item label="订单号" prop="orderNo">
            <el-input placeholder="请输入订单号" v-model="searchForm.orderNo" clearable></el-input>
          </el-form-item>

          <el-form-item label="用户ID" prop="userId">
            <el-input placeholder="请输入用户ID" v-model="searchForm.userId" clearable></el-input>
          </el-form-item>

          <el-form-item label="手机号" prop="userPhone">
            <el-input placeholder="请输入手机号" v-model="searchForm.userPhone" clearable></el-input>
          </el-form-item>

          <!-- 风险特征筛选 -->
          <el-form-item label="风险等级" prop="riskLevel">
            <el-select v-model="searchForm.riskLevel" placeholder="请选择风险等级" clearable>
              <el-option label="低风险" value="LOW"></el-option>
              <el-option label="中风险" value="MEDIUM"></el-option>
              <el-option label="高风险" value="HIGH"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="风控决策" prop="decision">
            <el-select v-model="searchForm.decision" placeholder="请选择风控决策" clearable>
              <el-option label="允许" value="ALLOW"></el-option>
              <el-option label="拦截" value="BLOCK"></el-option>
              <el-option label="需要3DS验证" value="REQUIRE_3DS"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="风险分值">
            <el-input placeholder="最小值" v-model="searchForm.totalScoreMin" clearable style="width: 100px;"></el-input>
            <span style="margin: 0 5px;">-</span>
            <el-input placeholder="最大值" v-model="searchForm.totalScoreMax" clearable style="width: 100px;"></el-input>
          </el-form-item>

          <!-- 业务和时间筛选 -->
          <el-form-item label="业务类型" prop="businessType">
            <el-select v-model="searchForm.businessType" placeholder="请选择业务类型" clearable>
              <el-option label="订单" value="ORDER"></el-option>
              <el-option label="改签" value="CHANGE"></el-option>
              <el-option label="退款" value="REFUND"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="检测时间">
            <el-date-picker
              v-model="searchForm.checkTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </template>

      <template slot='right'>
        <el-button icon="el-icon-refresh" @click="refresh">刷新</el-button>
      </template>
    </v-centerForm>

    <!-- 表格和分页 -->
    <v-tableEncapsulation
      :loading="loadingBtn.tableLoading"
      :columnData="columnData"
      :tableSize="pagination.size"
      :tableData="tableData"
      :tableTotal="pagination.total"
      :currentPage="pagination.current"
      @currentPage="handleCurrentChange"
      @sizeChange="handleSizeChange">

      <!-- 风险等级插槽 -->
      <el-table-column slot="riskLevel" label="风险等级" align="center" width="100px">
        <template slot-scope="scope">
          <el-tag :type="getRiskLevelTagType(scope.row.riskLevel)" effect="dark">
            {{ getRiskLevelText(scope.row.riskLevel) }}
          </el-tag>
        </template>
      </el-table-column>

      <!-- 风控决策插槽 -->
      <el-table-column slot="decision" label="风控决策" align="center" width="120px">
        <template slot-scope="scope">
          <el-tag :type="getDecisionTagType(scope.row.decision)" effect="dark">
            {{ getDecisionText(scope.row.decision) }}
          </el-tag>
        </template>
      </el-table-column>

      <!-- 操作列插槽 -->
      <el-table-column slot="operate" label="操作" align="center" width="100px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </v-tableEncapsulation>
  </div>
</template>

<script>
import { queryOrderRiskTraceList } from '@/api/risk/riskApi'

export default {
  name: 'orderRiskTraceList',

  data () {
    return {
      searchForm: {
        orderNo: null,
        userId: null,
        userPhone: null,
        riskLevel: null,
        decision: null,
        totalScoreMin: null,
        totalScoreMax: null,
        businessType: null,
        checkTimeRange: null
      },

      loadingBtn: {
        tableLoading: false
      },

      columnData: [
        { type: 'index', label: '序号', width: '60px' },
        { label: '检测时间', prop: 'checkTime', width: '160px' },
        { label: '订单号', prop: 'orderNo', width: '180px' },
        { slot: 'riskLevel' },
        { slot: 'decision' },
        { label: '风险分值', prop: 'totalScore', width: '100px' },
        { label: '命中规则数', prop: 'hitRulesCount', width: '120px' },
        { label: '业务类型', prop: 'businessTypeText', width: '100px' },
        { label: '订单金额', prop: 'orderAmount', width: '120px' },
        { label: '用户ID', prop: 'userId', width: '120px' },
        { label: '用户姓名', prop: 'userName', width: '120px' },
        { label: '手机号', prop: 'userPhone', width: '130px' },
        { label: '设备ID', prop: 'deviceId', width: '180px' },
        { label: 'IP地址', prop: 'ipAddress', width: '140px' },
        { label: '地理位置', prop: 'location', width: '200px' },
        { label: '检测耗时', prop: 'durationMs', width: '120px' },
        { slot: 'operate' }
      ],

      tableData: [],

      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },

  methods: {
    // 查询列表数据
    getTableData () {
      this.loadingBtn.tableLoading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        ...this.searchForm
      }

      // 处理检测时间范围
      if (params.checkTimeRange && params.checkTimeRange.length === 2) {
        params.checkTimeStart = params.checkTimeRange[0]
        params.checkTimeEnd = params.checkTimeRange[1]
      }
      delete params.checkTimeRange

      // 移除空值
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === '' || params[key] === undefined) {
          delete params[key]
        }
      })

      queryOrderRiskTraceList(params).then(({ data, code }) => {
        if (code === 0) {
          // 数据后处理
          this.tableData = (data.records || []).map(item => {
            let hitRulesCount = 0
            if (item.hitRules) {
              try {
                const rules = JSON.parse(item.hitRules)
                hitRulesCount = Array.isArray(rules) ? rules.length : 0
              } catch (e) {
                hitRulesCount = 0
              }
            }

            return {
              ...item,
              hitRulesCount,
              businessTypeText: this.getBusinessTypeText(item.businessType)
            }
          })
          this.pagination.total = data.total || 0
        }
        this.loadingBtn.tableLoading = false
      }).catch(() => {
        this.loadingBtn.tableLoading = false
      })
    },

    // 搜索
    search () {
      this.pagination.current = 1
      this.getTableData()
    },

    // 重置搜索
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.searchForm.checkTimeRange = null
      this.pagination.current = 1
      this.getTableData()
    },

    // 刷新
    refresh () {
      this.getTableData()
    },

    // 分页：页码变化
    handleCurrentChange (current) {
      this.pagination.current = current
      this.getTableData()
    },

    // 分页：每页条数变化
    handleSizeChange (size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.getTableData()
    },

    // 查看详情
    viewDetail (row) {
      this.$router.push({
        path: '/risk/order/trace',
        query: { orderNo: row.orderNo }
      })
    },

    // 风险等级标签类型
    getRiskLevelTagType (level) {
      const map = { 'LOW': 'success', 'MEDIUM': 'warning', 'HIGH': 'danger' }
      return map[level] || 'info'
    },

    // 风险等级文本
    getRiskLevelText (level) {
      const map = { 'LOW': '低风险', 'MEDIUM': '中风险', 'HIGH': '高风险' }
      return map[level] || '-'
    },

    // 风控决策标签类型
    getDecisionTagType (decision) {
      const map = { 'ALLOW': 'success', 'BLOCK': 'danger', 'REQUIRE_3DS': 'warning' }
      return map[decision] || 'info'
    },

    // 风控决策文本
    getDecisionText (decision) {
      const map = { 'ALLOW': '允许', 'BLOCK': '拦截', 'REQUIRE_3DS': '需3DS验证' }
      return map[decision] || '-'
    },

    // 业务类型文本
    getBusinessTypeText (type) {
      const map = { 'ORDER': '预定下单', 'CHANGE': '改签', 'REFUND': '退款' }
      return map[type] || '-'
    }
  },

  created () {
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
.order-risk-trace-list-container {
  padding: 20px;
  box-sizing: border-box;
  min-height: 100%;
  background: #fff;
}

::v-deep .listManager-btnGroup-wrap {
  margin-top: 0;
  margin-bottom: 20px;
  padding-top: 0;
}

::v-deep .v-tableEncapsulation {
  margin-top: 0;
}
</style>
